'use client'
import { determineReferralType } from '@/features/auth/utils'
import { useCaptureReferralParams, useReferralTracking } from '@/features/save-log'
import { useAccountStore } from '@/store'
import React from 'react'

type Props = {}

/**
 * Component xử lý tracking và log referral source
 *
 * Component này sử dụng 2 hooks từ feature save-log:
 * 1. useCaptureReferralParams: Capture referral params ngay khi user vào trang (chưa login)
 * 2. useReferralTracking: Log referral source khi user đăng nhập
 *
 * Workflow:
 * 1. **Capture Phase (chưa login)**:
 *    - useCaptureReferralParams tự động detect URL params
 *    - Parse và lưu vào localStorage với format IStoredReferralData
 *    - Set flag is_sent = false, captured_at = timestamp
 *
 * 2. **Tracking Phase (đã login)**:
 *    - useReferralTracking đọc data từ localStorage
 *    - Gọi API log action khi điều kiện thỏa mãn:
 *      + User đã đăng nhập
 *      + Referral data đã sẵn sàng và chưa sent
 *      + Chưa save action login (sal flag)
 *      + Đối với direct visit: đã qua 1 giờ kể từ lần log cuối
 *    - Set flag is_sent = true sau khi gọi API
 *    - Clear localStorage chỉ khi API thành công
 *
 * @returns null - Component này không render gì
 */
export const ReferralSourceLogin = (props: Props) => {
  // Lấy thông tin user và trạng thái đăng nhập
  const { data: userData, isAuthenticated } = useAccountStore()
  const isLoggedIn = isAuthenticated && !!userData

  // Capture referral params ngay khi vào trang (chưa cần login)
  useCaptureReferralParams({
    determineReferralTypeFn: determineReferralType,
    enabled: true,
    onCaptured: (data) => {
      console.log('[ReferralSourceLogin] Captured referral data:', data)
    },
  })

  // Track và log referral khi user login
  useReferralTracking({
    isLoggedIn,
    determineReferralTypeFn: determineReferralType,
    enabled: true,
  })

  // Component này không render UI
  return null
}
